import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'

import JsonToQuery from 'Utils/JsonToQuery'
import QueryToJson from 'Utils/QueryToJson'

/*
 Usage example:

 <SearchLink type="username" value="squir" wrap={true}>
  Add username=squir search param
 </SearchLink>
 */

export default class SearchLink extends React.Component {
  constructSearchParams(params, key, value, actAsToggle) {
    const newParams = Object.assign({}, params)

    if (typeof value === 'undefined') {
      delete newParams[key]
    } else if (actAsToggle && newParams[key] === value) {
      delete newParams[key]
    } else {
      newParams[key] = value
    }

    return newParams
  }

  onWrapTagClick(e) {
    if (e.target.children[0]) {
      e.target.children[0].click()
    }

    return false
  }

  render() {
    const searchParams = QueryToJson(window.location.search.substr(1))
    const isActive = searchParams[this.props.type] === this.props.value
    const className = this.props.className + (isActive ? ' is-active' : '')

    const newSearchParams = this.constructSearchParams(
      searchParams,
      this.props.type,
      this.props.value,
      this.props.actAsToggle
    )

    const to = `${window.location.pathname}?${JsonToQuery(newSearchParams)}`

    if (this.props.wrap) {
      if (this.props.wrapTagName === 'li') {
        return (
          <li className={className} onClick={this.onWrapTagClick}>
            <Link to={to}>
              {this.props.children}
            </Link>
          </li>
        )
      }
      return (
        <div className={className} onClick={this.onWrapTagClick}>
          <Link to={to}>
            {this.props.children}
          </Link>
        </div>
      )
    }
    return (
      <Link className={className} to={to}>
        {this.props.children}
      </Link>
    )
  }
}

SearchLink.propTypes = {
  className: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.string,
  wrap: PropTypes.bool,
  actAsToggle: PropTypes.bool,
  wrapTagName: PropTypes.string,
}

SearchLink.defaultProps = {
  value: '',
  wrap: false,
  actAsToggle: false,
  wrapTagName: 'div',
}
